import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";

import { Observable } from "rxjs";

export interface SetEditorAction {
  item: string;
  result?: Observable<boolean>;
}

export interface SetEditorLoader {
  filters: { search: string; page?: number };
  result?: Observable<string[]>;
}

@Component({
  selector: "set-editor",
  templateUrl: "./set-editor.html",
})
export class SetEditor implements OnInit {
  @Input() items: string[] = [];
  @Output() add: EventEmitter<SetEditorAction> = new EventEmitter<SetEditorAction>();
  @Output() remove: EventEmitter<SetEditorAction> = new EventEmitter<SetEditorAction>();
  @Output() load: EventEmitter<SetEditorLoader> = new EventEmitter<SetEditorLoader>();
  @Output() selectedItemClick: EventEmitter<string> = new EventEmitter<string>();

  searchCriteria: string;
  availableItems: string[];

  ngOnInit() {
    this.loadItems();
  }

  pageChanged(pageNumber: number) {
    this.loadItems(pageNumber);
  }

  updateSearchCriteria(criteria: string) {
    this.searchCriteria = criteria;
    this.loadItems();
  }

  loadItems(pageIndex?: number) {
    let args: SetEditorLoader = { filters: { search: this.searchCriteria, page: pageIndex } };
    this.load.emit(args);
    if (args.result) {
      args.result.subscribe((items) => (this.availableItems = items));
    }
  }

  addHandler(item: string) {
    if (!this.isSelected(item)) {
      let args: SetEditorAction = { item };
      this.add.emit(args);
      if (args.result) {
        args.result.subscribe((x) => this.addItem(item));
      } else {
        this.addItem(item);
      }
    }
  }

  removeHandler(item: string) {
    let args: SetEditorAction = { item };
    this.add.emit(args);
    if (args.result) {
      args.result.subscribe((x) => this.removeItem(item));
    } else {
      this.removeItem(item);
    }
  }

  selectedItemClickHandler(item: string) {
    this.selectedItemClick.emit(item);
  }

  isSelected(item: string) {
    return this.items.indexOf(item) >= 0;
  }

  addItem(item: string) {
    this.items.push(item);
  }

  removeItem(item: string) {
    let index = this.items.indexOf(item);
    if (index > -1) {
      this.items.splice(index, 1);
    }
  }
}
